import styled, { css } from 'styled-components'

const COLOR_DANGER = '#FF2929'
const COLOR_PRIMARY = '#1F35B5'
const COLOR_TEXT_DEFAULT = '#4B4B4B'
const COLOR_SURFACE = '#EDEDED'

export const Container = styled.div`
  display: grid;
  grid-template-columns: auto auto 1fr;
  gap: 16px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
`

export const CounterCard = styled.div`
  position: relative;
  background: ${COLOR_SURFACE};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  padding-top: 25px;
  align-items: center;
  min-width: 140px;
  width: 152px;
  height: 136px;

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    padding: 28px 16px;
  }
`

export const TooltipContent = styled.span`
  font-size: 12px;
  color: ${COLOR_TEXT_DEFAULT};
`

export const HelpButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #AEAEAE;
  transition: color 0.2s;

  &:hover {
    color: ${COLOR_TEXT_DEFAULT};
  }

  &:focus-visible {
    outline: 2px solid ${COLOR_PRIMARY};
    outline-offset: 2px;
    border-radius: 2px;
  }
`

type ValueColor = 'default' | 'primary' | 'danger'

const VALUE_COLORS: Record<ValueColor, string> = {
  default: COLOR_TEXT_DEFAULT,
  primary: COLOR_PRIMARY,
  danger: COLOR_DANGER,
}

interface ValueProps {
  $color?: ValueColor;
}

export const Value = styled.span<ValueProps>`
  font-size: 45px;
  font-weight: 700;
  line-height: 1;
  color: ${({ $color = 'default' }) => VALUE_COLORS[$color]};
`

export const Label = styled.span<ValueProps>`
  font-weight: 700;
  text-align: center;
  text-transform: lowercase;
  line-height: 16px;
  font-size: 16px;
  width: min-content;
  color: ${({ $color = 'default' }) => VALUE_COLORS[$color]};
`

export const Hint = styled.span`
  font-size: 12px;
  color: ${COLOR_DANGER};
  margin-top: 2px;
  font-weight: 500;
`

interface BannerProps {
  $variant: 'info' | 'danger';
}

export const Banner = styled.div<BannerProps>`
  display: flex;
  align-items: center;
  padding: 16px;
  border-radius: 10px;
  background-color: ${COLOR_SURFACE};

  @media (max-width: 768px) {
    grid-column: 1 / -1;
  }
`

export const BannerWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
`

export const BannerIcon = styled.div<BannerProps>`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ $variant }) =>
    $variant === 'danger'
      ? css`color: ${COLOR_DANGER};`
      : css`color: ${COLOR_TEXT_DEFAULT};`}
`

export const BannerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const BannerTitle = styled.span`
  font-size: 15px;
  font-weight: 700;
  color: ${COLOR_TEXT_DEFAULT};
`

export const BannerMessage = styled.span`
  font-size: 12px;
  color: ${COLOR_TEXT_DEFAULT};
  line-height: 1.5;
`
